import Component from '../core/Component';
import enquire from 'enquire.js';
import { queries } from '../core/config';

export default class Man extends Component {

    constructor($element) {
        super($element);
        this.elementBottom = parseInt(this.$element.css('bottom').replace('px', ''));
    }

    prepare() {

        enquire.register(queries.largeUp, {
            match: ::this.attach,
            unmatch: ::this.detach
        });

    }

    attach() {

        $(window).on('scroll load', event => {
            let scrollTop = $(window).scrollTop();

            if (scrollTop > 800) return;

            this.$element.animate({
                bottom: this.elementBottom - (scrollTop * 0.25) + 'px'
            }, 10);
        });

    }

    detach() {

    }

}


// WEBPACK FOOTER //
// ./components/Man.js